export const FormatCurrency = ({ value }) => {
  const format = { style: 'currency', currency: 'MXN' };
  const numberFormat2 = new Intl.NumberFormat('es-MX', format);
  return numberFormat2.format(value);
}
